import React, { useState } from "react";
import ps5 from "../../Images/psycotherapy4.png"
import Button from "../../commanfile/Button";
import Servicelist from "../../commanfile/Servicelist";
import ServiceSlider from "../../commanfile/ServiceSlider";
import therapy from "../../Images/psycotherapy.jpg";
import comitmentimg from "../../Images/commitment.jpg"
import { FaHandHoldingHeart } from "react-icons/fa6";

const Psycotherapy = () => {
  const symtams = [
    "Helps manage symptoms of depression, anxiety, and stress",
    "Improves emotional regulation and self-awareness",
    "Enhances coping skills for life’s challenges and trauma",
    "Builds healthier relationships and communication",
    "Supports recovery from addiction and harmful behaviors",
  ];
  const symtams1 = [
    "Increases confidence, motivation, and self-esteem",
    "Provides a safe space to express thoughts and emotions",
    "Reduces negative thinking patterns and self-blame",
    "Promotes long-term mental and emotional well-being",
    "Helps set and achieve personal and life goals",
  ];

  const Data = [
    {
      question: "What is psychotherapy?  ",
      answer: "Psychotherapy is a treatment that helps people manage emotional, mental, and behavioral problems through talking with a trained therapist."
    },
    {
      question: "How is psychotherapy different from counseling?",
      answer: "Psychotherapy often focuses on deeper, longer-term issues, while counseling usually addresses specific problems or life challenges in a shorter time frame."
    },
    {
      question: "Who can benefit from psychotherapy? ",
      answer: "Anyone facing emotional distress, mental health disorders, relationship issues, or life transitions can benefit from psychotherapy."
    },
    {
      question: "What kinds of problems can psychotherapy help with? ",
      answer: "Psychotherapy can help with anxiety, depression, trauma, stress, addiction, relationship problems, and coping with chronic illness."
    },
    {
      question: "How does psychotherapy work?  ",
      answer: "It works by exploring thoughts and feelings, identifying patterns, developing coping skills, and fostering personal growth."
    }, {
      question: "What are the different types of psychotherapy?  ",
      answer: "Types include cognitive-behavioral therapy (CBT), psychodynamic therapy, humanistic therapy, dialectical behavior therapy (DBT), and more."
    },
    {
      question: "How long does psychotherapy usually take?  ",
      answer: "Duration varies from a few sessions to several months or years based on the issue and goals."
    },
    {
      question: "Can psychotherapy be combined with medication?  ",
      answer: "Yes, psychotherapy can be combined with medication for better outcomes in many mental health conditions."
    },
    {
      question: "How do I know if I need psychotherapy?  ",
      answer: "Signs include persistent distress, difficulty coping, relationship conflicts, or feeling stuck in life."
    },
    {
      question: " Is everything I share in therapy confidential? ",
      answer: "Yes, therapy sessions are confidential, with some exceptions like risk of harm or legal requirements."
    },
    {
      question: "How do I prepare for my first psychotherapy session? ",
      answer: "	Preparing involves setting goals, being open, thinking about concerns, and finding a comfortable space."
    },
    {
      question: "	What happens in a typical therapy session?  ",
      answer: "Sessions typically involve discussing feelings, experiences, challenges, and working on strategies for change."
    }, {
      question: " How soon can I expect to feel better after starting therapy?  ",
      answer: "Some feel better after a few sessions, but lasting change usually requires ongoing work."
    },
    {
      question: "	Does psychotherapy work for children and teenagers?  ",
      answer: "Psychotherapy is effective for children and teenagers, often adapted to their developmental needs."
    },
    {
      question: "How do I choose the right therapist for me?  ",
      answer: "Choosing the right therapist involves considering qualifications, approach, comfort level, and fit with personal needs."
    },


  ]


  const [isOpen, setisOpen] = useState("null")

  const togglefaqs = (index) => {
    setisOpen(isOpen === index ? null : index)
  }


  return (
    <>
      <div className="max-w-[1456px] mt-2 mx-auto ">
        <div className=" shadow-2xl shadow-[#469B8F] pb-8 rounded-2xl">
          <ServiceSlider

            classname={"sm:flex"}
            title={"Psychotherapy"}
            content={
              " Taking Psychotherapy is not about weakness—it is all about courage. "
            }
            maincontent={
              "Talking to a therapist is not a sign of failure, but a step toward healing, growth, and self-discovery. It provides a safe space to share your thoughts, process emotions, and learn healthier ways to cope with life’s challenges. Whether you are struggling with stress, anxiety, depression, or simply seeking clarity, psychotherapy can guide you toward balance and resilience. Remember, asking for help is not giving up—it is choosing to move forward."}
            buttonname={"Explore Treatment Option "}
            imgs={therapy}
          />
        </div>
        <div className="py-16 ">
          <div className="text-center mx-auto border-b-4">
            <p className="font-roboto text-3xl line-clamp-5  ">
            
              The Power of Talk: How Psychotherapy Works
            </p>
            <div className="sm:flex items-center  justify-around py-8 ">
              <div className=" ">
                <img
                  src={ps5}
                  className="border-black mx-auto rounded-2xl h-[300px] w-[350px]"
                />
              </div>
              <div>
                <div className="lg:flex flex-wrap px-6 md:px-2 mx-auto lg:gap-14 ">
                  <div className=" ">
                    <Servicelist Symtams={symtams} />
                  </div>
                  <div className="">
                    <Servicelist Symtams={symtams1} />
                  </div>
                </div>
                <div className="mx-auto pt-10 ">
                  <Button
                    className={
                      "text-black hover:text-white font-roboto text-[20px] text-center items-center bg-[#50b1a4] p-1 rounded-full h-[40px] w-[200px]"
                    }
                    btnName={"Get Appointment"}
                    link={"/ContactUs"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto py-8">
          <div className="md:flex justify-around pt-3 px-2 items-center">
            <div className="md:w-[50%] w-full ">
              <p className=" flex gap-2 font-roboto font-semibold uppercase text-3xl text-[#469B8F]">
                <FaHandHoldingHeart />Committed to Restoring Hope and Mental Wellbeing.
             </p>

              <p className=" mx-auto text-justify text-lg py-5 px-5">
                Psynexa offers a wide range of psychotherapy treatments tailored
                to help individuals recognize and change unhealthy thoughts,
                emotions, and behaviors. We specialize in Cognitive Behavioral
                Therapy (CBT) to alter negative thought patterns, and Family
                Therapy to improve communication and resolve familial tensions.
                Our Dialectical Behavior Therapy (DBT) combines cognitive
                strategies with mindfulness for emotional regulation. Through
                Couple Counseling, we help partners navigate relationship
                difficulties, while Group Therapy provides peer support in a
                guided therapeutic setting. Biofeedback Therapy teaches
                self-regulation for stress and pain, and Marriage Counseling
                addresses issues like communication breakdowns, sexual
                difficulties, anger, infidelity, substance abuse, and parenting
                disagreements. Each therapy is aimed at promoting understanding,
                healing, and emotional well-being.
              </p>
            </div>
            <div className="">
              <img
                src={comitmentimg}
                className="w-[400px] h-[400px] border-dashed border-t-[30px] border-[#45b3a4] border-b-[30px] border-r-[30px] border-l-[30px] rounded-full "
                alt="images"
              />
            </div>
          </div>
        </div>

        <div className="mx-auto md:pl-[40px] md:pr-[40px] p-2 pt-10">
          <div className="mx-auto">
            <p className="text-2xl font-bold text-center font-roboto">FAQs</p>
          </div>
          <div className="space-y-4 mt-4">
            {Data.map((faq, index) => (
              <div key={index} className="border border-gray-200 w-[100%] mx-auto rounded-lg">
                <button
                  onClick={() => togglefaqs(index)}
                  className="w-full text-left px-4 py-3 flex justify-between items-center focus:outline-none"
                >
                  <span className="font-medium font-roboto">{faq.question}</span>
                  <span>{isOpen === index ? '-' : '+'}</span>
                </button>
                {isOpen === index && (
                  <div className="px-4 py-2 font-roboto text-justify text-gray-600">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Psycotherapy;
